import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { accessTask, CanPipe } from '@thehubz/client/core';

@Component({
  selector: 'sp-card',
  templateUrl: './sp-card.component.html',
  styleUrls: ['./sp-card.component.scss'],
})
export class SpCardComponent implements OnInit {
  @Input() cardData!: any;

  // send event on name click
  @Output() clickName = new EventEmitter<any>();

  // Send draft event oon click of card
  @Output() clickDraftCard = new EventEmitter<any>();

  // Info type of card
  @Input() type!: string;

  // members
  @Input() members: any = [];

  AccessTask = accessTask;
  loggedInUser!: any;
  flag = false;
  avatarSize = 40;
  avatarFontSize = 14;
  showNameToolTip = true;
  constructor(private router: Router, private route: ActivatedRoute, private canPipe: CanPipe) {
    // Do Something
  }

  ngOnInit(): void {
    this.flag = true;
    if (this.type == 'Task' || this.type == 'Sub-Task') {
      this.loggedInUser =
        this.cardData?.currentlyWithUser && this.cardData?.currentlyWithUser.name != '' ? this.cardData?.currentlyWithUser : this.cardData?.currentlyWithTeam;
    } else {
      this.loggedInUser = this.cardData?.createdBy;
    }
  }

  detailsView(data: any) {
    if (data.status && data.status != 'Draft') {
      if (this.type && this.type == 'project') {
        this.router.navigate(['/projects', 'detail', data._id], {
          relativeTo: this.route,
        });
      } else if (this.type && (this.type == 'Task' || this.type == 'Sub-Task')) {
        this.router.navigate(['/tasks/', 'detail', data._id]);
      }
    } else {
      if (this.canPipe.transform(this.AccessTask(data), 'create') || this.canPipe.transform(this.AccessTask(data), 'update')) {
        this.clickDraftCard.emit(data);
      }
    }
  }
}
